/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { string, shape, object } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Query } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import gql from 'graphql-tag';
import Grid from '@material-ui/core/Grid';

// components
import CountryFinder from '../../ContentTypeComponents/CountryFinder/CountryFinder';
import TrendingProductsBuilder from '../GraphqlCommonComponents/TrendingProducts/TrendingProductsBuilder';

// helpers
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';
import { GRAPHQL_ENV } from '../../../gql';

const styles = (theme) => ({
    countryFinder: {
        backgroundColor: theme.palette.common?.lightGray,
        margin: '50px 0 15px',
        [theme.breakpoints.down('sm')]: {
            margin: '30px 0 10px',
        },
    },
});

const Graphql404ErrorPage = ({
    brand, ssrDeviceType, page, classes,
}) => {
    const viewport = ssrDeviceType === 'tablet' ? 'desktop' : ssrDeviceType;
    let isTest = false;
    if (page?.path?.includes('-test') && GRAPHQL_ENV !== 'production') {
        isTest = true;
    }
    const determineLocale = () => {
        if (page?.path === '/canada') {
            return 'en-ca';
        }
        return 'en-us';
    };

    const HOMEPAGE_QUERY = gql`
            query HomePageQuery {
                findHomePage(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", locale: "${determineLocale()}", url: "/" viewport:  "${viewport}${isTest ? 'Test' : ''}") {
                    content
                    showUnderNavText
                }
            }
        `;
    return (
        <Query query={HOMEPAGE_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null;
                }
                if (error) {
                    mbpLogger.logError({
                        query: HOMEPAGE_QUERY,
                        component: 'Graphql404ErrorPage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                }
                if (data) {
                    const homeBlocks = data?.findHomePage?.content?.entries?.[0]?.home_blocks || null;
                    const countryFinder = homeBlocks?.[1]?.country_finder_widget?.country_finder_ref?.[0] || null;
                    const trendingProducts = homeBlocks?.[2]?.trending_products || null;
                    return (
                        <>
                            {countryFinder
                                        && (
                                            <div className={classes.countryFinder}>
                                                {countryFinder ? <CountryFinder data={countryFinder} ssrDeviceType={ssrDeviceType} pageType={page?.contentType} /> : null }
                                            </div>
                                        )}
                            {trendingProducts
                                    && (
                                        <Grid>
                                            {trendingProducts ? <TrendingProductsBuilder blockData={trendingProducts} ssrDeviceType={ssrDeviceType} pageType={page?.contentType} /> : null}
                                        </Grid>
                                    )}

                        </>
                    );
                }
                return null;
            }}
        </Query>
    );
};

Graphql404ErrorPage.propTypes = {
    classes: object.isRequired,
    ssrDeviceType: string.isRequired,
    brand: shape({
        'domain-name': string.isRequired,
    }).isRequired,
    page: shape({
        type: string.isRequired,
        path: string.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    ssrDeviceType: getSSRDeviceType(state),
});

const enhance = compose(
    withStyles(styles),
    connect(mapStateToProps),
);

export default enhance(Graphql404ErrorPage);
